import { useEffect, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box } from '@alf/uikit';
import { LOG_ACTIONS, logNewRelicAction } from '@namespace/analytics';
import { useOtherSettings } from '@namespace/cms';
import Control from '../../common/Control';
import useOnChangeValidate from '../../hooks/useOnChangeValidate';

import styles from './index.module.css';

export const ReCaptchaField = ({
  name,
  count,
  isOnChangeValidation = false,
  action = 'Login' // can't use as constant now allowed import
}) => {
  const onChangeRef = useRef(() => {});
  const { reCaptchaConfig = {} } = useOtherSettings();
  const { reCaptchaWidgetId = '' } = reCaptchaConfig;

  const methods = useFormContext();
  const { control } = methods;

  useOnChangeValidate({ name, isOnChangeValidation });

  useEffect(() => {
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.render('recaptcha-challenge', {
        sitekey: reCaptchaWidgetId,
        action,
        callback: (token) => {
          logNewRelicAction(LOG_ACTIONS.RECAPTCHA_WIDGET_SUCCESS, {
            message: 'Received new challenge token',
            count
          });
          onChangeRef.current(token);
        }
      });
    });
  }, [reCaptchaWidgetId, action, count]);

  if (!reCaptchaWidgetId) {
    return null;
  }
  return (
    <Control
      key={count}
      id={name}
      classNames={{ wrapperClassName: styles.wrapper }}
    >
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const { onChange: controllerOnChange } = field;
          onChangeRef.current = controllerOnChange;
          logNewRelicAction(LOG_ACTIONS.RECAPTCHA_WIDGET_SUCCESS, {
            message: 'Render widget challenge'
          });
          return (
            <Box justify="center" flexGrow={1}>
              <Box id="recaptcha-challenge" />
            </Box>
          );
        }}
      />
    </Control>
  );
};
